import axios from 'axios'

const LostItemService = {
  async getList (params = {}) {
    return axios.get('admin/lf-items', { params })
  },

  async show (id) {
    return axios.get(`admin/lf-items/${id}`)
  },

  async store (data) {
    return axios.post('admin/lf-items', data)
  },

  async update (id, data) {
    return axios.put(`admin/lf-items/${id}`, data)
  },

  async destroy (id) {
    return axios.delete(`admin/lf-items/${id}`)
  },

  async updateStatus (id, data) {
    return axios.patch(`admin/lf-items/${id}/status`, data)
  }
}

export default LostItemService
